import { useEffect, useState } from 'react'

import { SEARCH_DEBOUNCE_DELAY_MS } from '../utils/constants'

export function useDebounce<T>(
  value: T,
  delay: number = SEARCH_DEBOUNCE_DELAY_MS
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
